'use client';

import { useSyncExternalStore } from 'react';
import {
  PALETTES,
  PALETTE_LABELS,
  PALETTE_SWATCH,
  type Palette,
  getServerSnapshot,
  getTheme,
  setTheme,
  subscribeTheme,
} from '@/lib/theme';

/**
 * Theme palette picker for the Settings page. DESIGN.md §3.4.
 *
 * State is read via `useSyncExternalStore` so SSR and the hydrated client
 * agree without an effect-driven dance.
 */
export function ThemePicker() {
  const palette = useSyncExternalStore(subscribeTheme, getTheme, getServerSnapshot);

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
      {PALETTES.map((p) => {
        const active = palette === p;
        const [start, end] = PALETTE_SWATCH[p];
        return (
          <button
            key={p}
            type="button"
            onClick={() => setTheme(p)}
            aria-pressed={active}
            className={
              'pressable group flex flex-col items-center gap-2 rounded-md bg-surface p-3 text-sm transition-shadow ' +
              (active ? 'shadow-md ring-2 ring-strong' : 'shadow-sm hover:shadow-md')
            }
          >
            <span
              className="block h-12 w-full rounded-sm"
              style={{ backgroundImage: `linear-gradient(135deg, ${start}, ${end})` }}
              aria-hidden
            />
            <span className="font-medium text-fg-primary">{PALETTE_LABELS[p as Palette]}</span>
          </button>
        );
      })}
    </div>
  );
}
